export const allowedTransactionTypes = {
  originalPaymentMethod: 'return',
  instantRefund: 'refund',
  exchange: 'exchange',
  instantExchange: 'instant_exchange',
}

export const allowedExchangeMethods = {
  variants: 'same_product_variants',
  otherProducts: 'other_products',
  otherProductsVariants: 'other_product_variants',
}

export const currencies = {
  EUR: 'EUR',
  GBP: 'GBP',
}

export const inputMaxLengths = {
  line_1: 45,
  line_2: 45,
  postcode: 16,
  province: 64,
  locality: 64,
  orderNumber: 64,
  orderEmail: 128,
  house_number: 45,
  first_name: 64,
  last_name: 64,
}

export const allowedLanguages = [
  { label: 'ES - Español', value: 'es' },
  { label: 'EN - English', value: 'en' },
  { label: 'FR - Français', value: 'fr' },
  { label: 'IT - Italiano', value: 'it' },
  { label: 'PT - Português', value: 'pt' },
  { label: 'DE - Deutsch', value: 'de' },
  { label: 'NL - Dutch', value: 'nl' },
  { label: 'KO - 한국어', value: 'ko' },
]

export const deliveryMethods = {
  customerDelivers: 'customerdelivers',
  pickupPoint: 'pickuppoint',
  customerPickup: 'customerpickup',
  returnToStore: 'returntostore',
}

export const extraCreditFeeType = {
  fixedAmount: 'fixed_amount',
  percentage: 'percentage',
  deliveryMethodFee: 'delivery_method_fee',
}

export const actionTypes = {
  refund: 'refund',
  exchange: 'exchange',
  cancellation: 'cancellation',
}

export const orderTransactionTypes = {
  refund: 'refund',
  exchange: 'exchange',
  mixed: 'mixed',
}

export const portalTypes = {
  cancellations: 'cancellations',
  returnToSender: 'return_to_sender',
  returnAndExchange: 'return_and_exchange',
}

export const phoneAttributesByEventName = {
  phonePrefix: 'prefix',
  phone: 'number',
}

export const DEFAULT_SENTRY_TRACES_SAMPLE_RATE = 0.05
